// extracted by mini-css-extract-plugin
export default {"receipt":"receipt_receipt__hyBng"};